var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4219 0 16 3.57812 16 8C16 12.4219 12.4219 16 8 16C3.57812 16 0 12.4219 0 8C0 3.57812 3.57812 0 8 0ZM8 15.0156C11.8594 15.0156 15 11.8594 15 8C15 4.14062 11.8594 1 8 1C4.14062 1 1 4.14062 1 8C1 11.8594 4.14062 15.0156 8 15.0156ZM4.5 8.5C4.21875 8.5 4 8.28125 4 8C4 7.71875 4.21875 7.5 4.5 7.5H11.5C11.7812 7.5 12 7.71875 12 8C12 8.28125 11.7812 8.5 11.5 8.5H4.5Z",
    fill: "#8276F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5H11.5C11.7812 8.5 12 8.28125 12 8C12 7.71875 11.7812 7.5 11.5 7.5H4.5C4.21875 7.5 4 7.71875 4 8C4 8.28125 4.21875 8.5 4.5 8.5Z",
    fill: "#8276F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4219 12.4219 16 8 16C3.57812 16 0 12.4219 0 8C0 3.57812 3.57812 0 8 0C12.4219 0 16 3.57812 16 8ZM0.984375 8C0.984375 11.8594 4.14062 15 8 15C11.8594 15 15 11.8594 15 8C15 4.14062 11.8594 1 8 1C4.14062 1 0.984375 4.14062 0.984375 8ZM7.5 4.5C7.5 4.21875 7.71875 4 8 4C8.28125 4 8.5 4.21875 8.5 4.5V11.5C8.5 11.7812 8.28125 12 8 12C7.71875 12 7.5 11.7812 7.5 11.5L7.5 4.5Z",
    fill: "#8276F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5L7.5 11.5C7.5 11.7812 7.71875 12 8 12C8.28125 12 8.5 11.7812 8.5 11.5V4.5C8.5 4.21875 8.28125 4 8 4C7.71875 4 7.5 4.21875 7.5 4.5Z",
    fill: "#8276F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6bb14aaba241541f4d4e0089cba655d2.svg";
export { ForwardRef as ReactComponent };